/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_LocationsInputs */

const de__field_locations = /** @type {(inputs: _Field_LocationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Räume`)
};

/**

* @param {_Field_LocationsInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _field_locations = /** @type {((inputs?: _Field_LocationsInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_LocationsInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_locations(inputs)
});